import { LogsConsultaListSearchComponent } from './LogsConsultaListSearchComponent'

export const LogsConsultaListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <LogsConsultaListSearchComponent />
    </div>
  )
}
